/* global femcare, addeventatc */

femcare.form.periodTracker = {

    init: function () {
        if ($('.period-tracker').length) {
            var datepickerLoaded = !!$.fn.datepicker;

            if (datepickerLoaded) {
                this.prepareSections();
            } else {
                var assetsPath = femcare.shared.util.getAssetsPath();
                $.getScript(assetsPath + '/js/datepicker.js', function () {
                    this.prepareSections();
                }.bind(this));
            }
        }
    },

    prepareSections: function () {
        this.addToCalendarInit();
        this.getPeriodTrackerScript();
        this.initInputTooltips();
        this.initLegendTooltips();
    },

    addToCalendarInit: function () {
        window.addeventasync = function () {
            addeventatc.settings({
                appleical: { show: true, text: 'Apple Calendar' },
                google: { show: true, text: 'Google <em>(online)</em>' },
                outlook: { show: true, text: 'Outlook' },
                outlookcom: { show: false, text: 'Outlook.com <em>(online)</em>' },
                yahoo: { show: false, text: 'Yahoo <em>(online)</em>' }
            });
        };
    },

    getPeriodTrackerScript: function () {
        var assetsPath = femcare.shared.util.getAssetsPath();
        $.getScript(assetsPath + '/js/period-tracker.js');
    },

    initInputTooltips: function () {
        $('.period-tracker__input-description').each(function (index, element) {
            var $element = $(element);
            var $icon = $element.find('.period-tracker-info__icon');
            var $tooltip = $element.find('.period-tracker-info__tooltip-content');

            $element.tooltip({
                items: $icon,
                content: $tooltip.html(),
                position: { my: 'left-50% bottom-20', at: 'center' },
                classes: {
                    'ui-tooltip': 'tooltip tooltip--period-tracker-input',
                    'ui-tooltip-content': 'tooltip__content tooltip__content--period-tracker-input'
                }
            });
        });
    },

    initLegendTooltips: function () {

        var $element = $('.period-tracker-legend');
        var $icon = $element.find('.period-tracker-legend-info__icon');
        var $tooltip = $element.find('.period-tracker-legend-info__tooltip-content');

        $element.tooltip({
            items: $icon,
            content: $tooltip.html(),
            position: { my: 'left-50% bottom-20', at: 'center' },
            classes: {
                'ui-tooltip': 'tooltip tooltip--period-tracker-legend',
                'ui-tooltip-content': 'tooltip__content tooltip__content--period-tracker-legend'
            }
        });
    }
};
